var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconModem48(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.433 31.6758H7.08428C5.93319 31.6758 5 32.5541 5 33.6375V38.5417C5 39.6251 5.93319 40.5034 7.08428 40.5034H40.433C41.5841 40.5034 42.5173 39.6251 42.5173 38.5417V33.6375C42.5173 32.5541 41.5841 31.6758 40.433 31.6758Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1382 15.124V31.6758",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1382 36.0898H18.2416",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.793 36.0898H35.8964",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2759 36.0898H30.3793",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4134 16.3718C18.937 16.3718 20.1721 15.1367 20.1721 13.6131C20.1721 12.0896 18.937 10.8545 17.4134 10.8545C15.8899 10.8545 14.6548 12.0896 14.6548 13.6131C14.6548 15.1367 15.8899 16.3718 17.4134 16.3718Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2859 10.709C10.6265 11.68 10.2412 12.8521 10.2412 14.1143C10.2412 15.358 10.6154 16.5145 11.2572 17.4771",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.34105 8.50293C6.38378 9.97314 5.82764 11.7285 5.82764 13.6136C5.82764 15.5044 6.38709 17.2644 7.34949 18.7373",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5117 10.3535C24.1711 11.3245 24.5565 12.4967 24.5565 13.7589C24.5565 15.0027 24.1823 16.159 23.5404 17.1216",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4567 8.64844C28.4139 10.1186 28.9701 11.874 28.9701 13.7591C28.9701 15.6499 28.4106 17.4099 27.4482 18.8828",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconModem48);
export default __webpack_public_path__ + "static/media/pictogramBeaconModem48.37a8f7489d1be4aef471441111d7fa36.svg";
export { ForwardRef as ReactComponent };